window.SnoozebabyMobileStickyAtc = {
  instances: new Map(),

  init(elementId) {
    const element = document.getElementById(elementId);
    if (!element || this.instances.has(elementId)) return;

    const instance = new StickyAtcBar(element);
    this.instances.set(elementId, instance);
    instance.connect();
  },
};

class StickyAtcBar {
  constructor(element) {
    this.element = element;
    this.sectionId = element.dataset.sectionId;
    this.mediaQuery = window.matchMedia('(max-width: 749px)');
    this.pastBuyButtons = false;
    this.hasSeenBuyButtons = false;
    this.nearFooter = false;
    this.mainSubmit = null;
    this.mainPrice = null;
    this.stickyPrice = element.querySelector('[data-sticky-price]');
    this.stickyButton = element.querySelector('[data-sticky-submit]');
    this.buyButtonsTarget = null;
    this.barHeight = 0;
  }

  resolveElements() {
    this.mainSubmit = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
    this.mainPrice = document.getElementById(`price-${this.sectionId}`);
    this.buyButtonsTarget =
      this.mainSubmit ||
      document.querySelector('.sb-pdp-buy-row') ||
      document.querySelector('.product-form__buttons');
  }

  connect() {
    this.resolveElements();

    if (!this.mainSubmit || !this.stickyButton) {
      window.requestAnimationFrame(() => {
        this.resolveElements();
        if (!this.mainSubmit || !this.stickyButton) return;
        this.finishConnect();
      });
      return;
    }

    this.finishConnect();
  }

  finishConnect() {
    this.syncFromMain();
    this.updateBarHeight();

    this.stickyButton.addEventListener('click', (event) => {
      event.preventDefault();
      if (this.mainSubmit.disabled || this.mainSubmit.getAttribute('aria-disabled') === 'true') {
        return;
      }
      this.mainSubmit.click();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.variantUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (event.data?.sectionId !== this.sectionId) return;
        window.requestAnimationFrame(() => this.syncFromMain());
      });
    }

    this.setupObservers();
    this.onScroll = () => this.updateVisibility();
    this.onResize = () => {
      this.updateBarHeight();
      this.updateVisibility();
    };
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize, { passive: true });
    this.mediaQuery.addEventListener('change', () => this.updateVisibility());
    this.updateVisibility();
  }

  updateBarHeight() {
    this.barHeight = this.element.getBoundingClientRect().height || 0;
    document.documentElement.style.setProperty(
      '--sb-sticky-atc-height',
      this.barHeight ? `${Math.ceil(this.barHeight)}px` : '5rem'
    );
  }

  syncFromMain() {
    if (this.mainPrice && this.stickyPrice) {
      this.stickyPrice.innerHTML = this.mainPrice.innerHTML;
    }

    if (!this.mainSubmit || !this.stickyButton) return;

    const isDisabled =
      this.mainSubmit.disabled || this.mainSubmit.getAttribute('aria-disabled') === 'true';
    this.stickyButton.disabled = isDisabled;

    const mainText = this.mainSubmit.querySelector(
      'span:not(.sb-cta__icon):not(.loading__spinner)'
    );
    const stickyText =
      this.stickyButton.querySelector('[data-sticky-label]') ||
      this.stickyButton.querySelector('span:not(.sb-cta__icon):not(.loading__spinner)');
    if (mainText && stickyText) {
      stickyText.textContent = mainText.textContent;
    }

    this.syncStickyIcon(isDisabled);
  }

  syncStickyIcon(isDisabled) {
    if (!this.stickyButton) return;

    const existingIcon = this.stickyButton.querySelector('.sb-cta__icon');
    if (isDisabled) {
      existingIcon?.remove();
      return;
    }

    if (existingIcon) return;

    const mainIcon = this.mainSubmit?.querySelector('.sb-cta__icon');
    if (mainIcon) {
      this.stickyButton.insertBefore(mainIcon.cloneNode(true), this.stickyButton.firstChild);
    }
  }

  setupObservers() {
    if (!this.buyButtonsTarget) return;

    this.buyObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) this.hasSeenBuyButtons = true;
          this.updateVisibility();
        });
      },
      { threshold: 0 }
    );
    this.buyObserver.observe(this.buyButtonsTarget);

    const footer = document.querySelector('footer.footer, .footer, .shopify-section-group-footer-group');
    if (footer) {
      this.footerObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.nearFooter = entry.isIntersecting;
            this.updateVisibility();
          });
        },
        { threshold: 0, rootMargin: '0px 0px 0px 0px' }
      );
      this.footerObserver.observe(footer);
    }
  }

  updateVisibility() {
    if (!this.mediaQuery.matches) {
      this.element.classList.remove('is-visible');
      this.element.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('sb-mobile-sticky-atc-active');
      return;
    }

    if (this.buyButtonsTarget && !this.buyObserver) {
      this.setupObservers();
    }

    if (this.buyButtonsTarget) {
      const rect = this.buyButtonsTarget.getBoundingClientRect();
      const inView = rect.bottom > 0 && rect.top < window.innerHeight;
      if (inView) this.hasSeenBuyButtons = true;
      this.pastBuyButtons = this.hasSeenBuyButtons && rect.bottom <= 0;
    }

    const footer = document.querySelector('footer.footer, .footer, .shopify-section-group-footer-group');
    if (footer) {
      const footerRect = footer.getBoundingClientRect();
      const buffer = this.barHeight || 80;
      this.nearFooter = footerRect.top < window.innerHeight - buffer;
    }

    const show = this.pastBuyButtons && !this.nearFooter;
    this.element.classList.toggle('is-visible', show);
    this.element.setAttribute('aria-hidden', show ? 'false' : 'true');
    document.documentElement.classList.toggle('sb-mobile-sticky-atc-active', show);

    if (show) {
      this.updateBarHeight();
    }
  }
}
